import React, { Component } from 'react';
import {
	HashRouter as Router,
	withRouter,
	Switch,
	Route
} from 'react-router-dom';
import { connect, Provider } from 'react-redux';
import store from 'store';

import RouteWithSubRoutes from 'pub-comp/routeWithSubRoutes';
import loginRoutes from 'router/login.js';
import loginRoutesEn from 'router/loginEn.js';//由于官方首页多语下两套设计：中繁和英文

const NoMatch = ({ history }) => {
	history.replace('');
	return <div />;
};

@withRouter
class Root extends Component {
	constructor(props) {
		super(props);
		this.state = {
			defaultLan: 'zh_CN',    //默认是中文
		};
		this.isLogin = window.os_fe_isLogin && window.os_fe_isLogin();
	}
	componentWillMount() {
		if (!this.isLogin) {
			const currentLan = window.getCurrentLangCode && window.getCurrentLangCode();
			if (currentLan) {
				this.setState({
					defaultLan: currentLan,
				});
			}
		}
	}

	judgeRoute = () => {
    const duoyuRoutes = this.state.defaultLan === 'en_US' ? loginRoutesEn : loginRoutes;
		return duoyuRoutes.map((route, i) => <RouteWithSubRoutes key={i} {...route} />);
	}

	render() {
		const subRoute = this.judgeRoute();
		if (!subRoute) return null;
		return (
			<div>
				<Switch>
					{subRoute}
					<Route component={NoMatch} />
				</Switch>
			</div>
		);
	}
}

const App = () => (
  <Provider store={store} >
		<Router>
			<Root />
		</Router>
  </Provider>
);

export default App;

